import { getCloudinaryFetchUrl, TransformationOptions } from './cloudinary';

export function getSrcSet(
  baseUrl: string,
  sizes: Array<number>,
  aspectRatio?: number,
  transformations?: TransformationOptions
) {
  // Somewhat arbitrary based on our GA screen dimensions and estimated pixel densities
  const srcSetSizes = sizes || [375, 750, 1125, 1920, 2880];

  let srcSet = '';

  if (aspectRatio) {
    srcSetSizes.forEach((size, index) => {
      const url = getCloudinaryFetchUrl(baseUrl, {
        width: size,
        height: Math.round(size / aspectRatio),
        ...transformations,
      });
      if (index !== 0) srcSet += ', ';
      srcSet += `${url} ${size}w`;
    });
  } else {
    srcSetSizes.forEach((size, index) => {
      const url = getCloudinaryFetchUrl(baseUrl, {
        width: size,
        ...transformations,
      });
      if (index !== 0) srcSet += ', ';
      srcSet += `${url} ${size}w`;
    });
  }

  if (srcSet === '') return null;
  return srcSet;
}
